<template>
    <ul class="gongwuchetab">
        <li @click="change(item)" 
        :class="{active:now==item.id}" 
        v-for="(item,index) in list" :key="index">
        {{ item.name }}
    </li>
    </ul>
</template>
<script>
export default {
    data() {
        return {
            list: [
                {
                    id: 1,
                    name: '按里程'
                },
                {
                    id: 2,
                    name: '按订单'
                },
            ],
            now:1
        }
    },
    methods: {
        change(item) {
            this.now=item.id;
            this.$emit('now',this.now);
        }
    }
}
</script>
<style>
.gongwuchetab{
    display: flex;
}
.gongwuchetab li{
    opacity: 0.5;
    color:#fff;
    margin-left: 10px;
    cursor: pointer;
}
.gongwuchetab li.active{
    opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/tab.vue